import { axiosApiInstance, headers } from './_httpHeaders';

// 1. 통계 데이터 요청
export const getStatisticsList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/dashBoard/selectStatisticsList.do`,
    params: {
      usCode: reqParam.usCode,
      distributorOrder: reqParam.distributorOrder,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
      pageSecondStart: 0,
      pageSecondPageNum: 5,
    },
  });

// 2. 참고문서 다운로드
export const getDocumentFileDownload = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'blob',
    url: `${process.env.REACT_APP_API_URL}/user/dashBoard/documentFileDownload.do`,
    params: {
      docType: reqParam.docType,
    },
  });
